export default "__VITE_ASSET__BcBrOY1z__"